// src/services/userService.js
import {
  collection, doc, getDoc, updateDoc,
  query, where, onSnapshot, orderBy, setDoc, serverTimestamp,
} from "firebase/firestore";
import { db } from "./firebase";

function sortDesc(docs) {
  return docs
    .map(d => ({ id: d.id, ...d.data() }))
    .sort((a, b) => (b.createdAt?.seconds ?? 0) - (a.createdAt?.seconds ?? 0));
}

// التعديل هنا: أضفنا شرط الحالة 'approved' ليتوافق مع الـ Rules
export function subscribeUsersByRole(role, callback, onError) {
  let q;

  if (role === "captain") {
    // إذا كان المطلوب كباتن، يجب طلب المعتمدين فقط لتجنب خطأ Permission Denied
    q = query(
      collection(db, "users"),
      where("role", "==", "captain"),
      where("status", "==", "approved")
    );
  } else {
    // للمRoles الأخرى (مثل الأدمن)
    q = query(collection(db, "users"), where("role", "==", role));
  }

  return onSnapshot(q,
    snap => callback(sortDesc(snap.docs)),
    err => {
      console.error("Error in subscribeUsersByRole:", err.code);
      if (onError) onError(err);
    }
  );
}

export function subscribePendingCaptains(callback, onError) {
  const q = query(
    collection(db, "users"),
    where("role", "==", "captain"),
    where("status", "==", "pending")
  );
  return onSnapshot(q,
    snap => callback(sortDesc(snap.docs)),
    err => { console.error("subscribePendingCaptains:", err.code); onError?.(err); }
  );
}

export async function approveCaptain(captainId) {
  await updateDoc(doc(db, "users", captainId), {
    status: "approved",
    available: true,
    approvedAt: serverTimestamp(),
  });
}

export async function rejectCaptain(captainId) {
  await updateDoc(doc(db, "users", captainId), { status: "rejected" });
}

export async function toggleCaptainDisabled(captainId, currentlyDisabled) {
  await updateDoc(doc(db, "users", captainId), {
    disabled: !currentlyDisabled,
    available: false,
  });
}

export async function updateClientProfile(userId, { name, phone }) {
  await updateDoc(doc(db, "users", userId), { name, phone });
}

export async function updateCaptainCarPhotos(captainId, carPhotoUrls) {
  await updateDoc(doc(db, "users", captainId), { carPhotoUrls });
}

export function subscribeSettings(callback) {
  return onSnapshot(doc(db, "config", "settings"), snap => {
    if (snap.exists()) callback(snap.data());
  }, err => console.error("subscribeSettings:", err.code));
}

export async function updateSettings(settings) {
  await setDoc(doc(db, "config", "settings"), settings, { merge: true });
}

export async function getUser(uid) {
  const snap = await getDoc(doc(db, "users", uid));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}